import { loadProfileData, loadGalleryData } from './utils'
import {
  getStorageZip,
  getUserDataFromStorage
} from '../../services/geoCoordinatesLookup'

class DynamicAdvisorComponent extends HTMLElement {
  profile = this.querySelector('advisor-profile')

  loadProfile() {
    if (this.profile) {
      this.profile.hidden = false
      loadProfileData(this.profile.profileID)
        .then(advisor => this.profile.renderProfile(advisor))
        .catch(() => {
          this.profile.hidden = true
          this.loadGallery()
        })
    }
  }

  connectedCallback() {
    if (this.profile) {
      this.loadProfile()
    }
  }
}

customElements.define('dynamic-advisor-component', DynamicAdvisorComponent)
